<form [formGroup]="questionForm" (ngSubmit)="onSubmit()" novalidate class="form-horizontal" style="margin-top: 100px;">
    
    <div class="form-group col-xs-12">
      <label class="col-sm-2 control-label" >Question</label>
      <div class="col-sm-6">
        <input formControlName="question_text" class="form-control">
      </div>
    </div>

    <div class="form-group col-xs-12">
      <label class="col-sm-2 control-label" >Component</label>
      <div class="col-sm-6">
        <select formControlName="component" class="form-control">
          <option *ngFor="let component of components" [value]="component.id">{{component.name}}</option>
        </select>
      </div>
    </div>

    <div class="form-group col-xs-12">
      <label class="col-sm-2 control-label" >Type of Question</label>
      <div class="col-sm-6">
        <select formControlName="description" class="form-control">
          <option *ngFor="let description of descriptions" [value]="description">{{description}}</option>
        </select>
      </div>
    </div>


    <div class="form-group col-xs-12">    
      <label class="col-sm-2 control-label" *ngIf="questionForm.value.description > 1">Option1</label>
      <div class="col-sm-6">
        <input class="form-control" formControlName="option1" *ngIf="questionForm.value.description >= 2">
      </div>
    </div>

    <div class="form-group col-xs-12">
      <label class="col-sm-2 control-label" *ngIf="questionForm.value.description > 1">Option2</label>
      <div class="col-sm-6">
        <input class="form-control" formControlName="option2" *ngIf="questionForm.value.description >= 2">
      </div>
    </div>

    <div class="form-group col-xs-12">
      <label class="col-sm-2 control-label" *ngIf="questionForm.value.description >= 3">Option3</label>
      <div class="col-sm-6">
        <input class="form-control" formControlName="option3" *ngIf="questionForm.value.description >= 3">
      </div>
    </div>

    <div class="form-group col-xs-12">
      <label class="col-sm-2 control-label" *ngIf="questionForm.value.description >= 4">Option4</label>
      <div class="col-sm-6">
        <input class="form-control" formControlName="option4" *ngIf="questionForm.value.description >= 4">
      </div>
    </div>

    <div class="form-group col-xs-12">
     <div class="col-sm-offset-2 col-sm-6">
      <button class="btn btn-primary" type="submit" [disabled]="questionForm.pristine">Save
          <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />      
      </button>
      <button class="btn btn-primary" type="reset" (click)="revert()" [disabled]="questionForm.pristine">Revert</button>
    </div>
  </div>

</form>


// WEBPACK FOOTER //
// ./src/app/sdg/add-question/add-question.component.html